// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"86492de7","239":"1f354352","732":"1251d11d"}[chunkId] + ".chunk.js";
};